"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCountries = void 0;
const constants_1 = require("../constants");
const basic_types_1 = require("../constants/generated/basic-types");
const supported_countries_json_1 = __importDefault(require("../constants/generated/supported-countries.json"));
/*
  The "stage" attribute of the markets/{brand}-{country}.json config is
  meant to be read as the highest environment a market is supported.
  This means that if BK-DE has its "stage" attribute set to "prod", that
  means the market is supported UP TO PROD ("dev", "staging", "qa", "prod").

  This util gets the lowest stage from a list of stages, and returns a list
  of the lowest stage and every stage higher than itself. E.g. it maps
  - ['dev']             => ['dev', 'staging', 'qa', 'prod']
  - ['prod']            => ['prod']
  - ['prod', 'staging'] => ['staging', 'qa', 'prod']
  - ['none', 'qa']      => ['none', 'dev', 'staging', 'qa', 'prod']
*/
const getLowestStageAndHigher = (stages) => {
    if (stages.length === 0) {
        return [];
    }
    const lowestStage = stages.sort((a, b) => {
        return constants_1.ALL_STAGES.indexOf(a) - constants_1.ALL_STAGES.indexOf(b);
    })[0];
    return constants_1.ALL_STAGES.slice(constants_1.ALL_STAGES.indexOf(lowestStage));
};
const getSupportedCountries = (options) => {
    var _a, _b, _c;
    const brands = (options === null || options === void 0 ? void 0 : options.brands)
        ? options.brands.map((x) => (0, basic_types_1.asBrand)(x)).filter((x) => !!x)
        : constants_1.ALL_BRANDS;
    const awsRegions = (options === null || options === void 0 ? void 0 : options.awsRegions)
        ? options.awsRegions.map((x) => (0, basic_types_1.asAwsRegion)(x)).filter((x) => !!x)
        : constants_1.ALL_AWS_REGIONS;
    const stages = (options === null || options === void 0 ? void 0 : options.stages)
        ? getLowestStageAndHigher(options.stages.map((x) => (0, basic_types_1.asStage)(x)).filter((x) => !!x))
        : constants_1.ALL_STAGES;
    let supportedRegions = [];
    for (const brand of brands) {
        for (const awsRegion of awsRegions) {
            for (const stage of stages) {
                supportedRegions = [
                    ...supportedRegions,
                    ...((_c = (_b = (_a = supported_countries_json_1.default[brand]) === null || _a === void 0 ? void 0 : _a[awsRegion]) === null || _b === void 0 ? void 0 : _b[stage]) !== null && _c !== void 0 ? _c : []),
                ];
            }
        }
    }
    return supportedRegions;
};
exports.getSupportedCountries = getSupportedCountries;
